import { useTranslation } from 'react-i18next'
import { Logo } from './Logo'

export function MaintenancePage() {
  const { t } = useTranslation()
  return (
    <div className="min-h-screen bg-muted flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-card p-8 max-w-md w-full text-center shadow-sm">
        <div className="flex justify-center mb-6">
          <Logo size={120} />
        </div>

        <h1 className="text-h1 text-foreground mb-4">
          {t('maintenance.title')}
        </h1>

        <p className="text-body text-muted-foreground mb-6">
          {t('maintenance.message')}
        </p>

        <p className="text-small text-muted-foreground">
          {t('maintenance.apology')}
        </p>
      </div>

      <footer className="mt-8 text-center text-small text-muted-foreground">
        <a href="https://gam-medical.de/impressum/" target="_blank" rel="noopener noreferrer" className="hover:underline">
          {t('common.impressum')}
        </a>
        <span className="mx-2">|</span>
        <a href="https://gam-medical.de/agb/" target="_blank" rel="noopener noreferrer" className="hover:underline">
          {t('common.agb')}
        </a>
        <span className="mx-2">|</span>
        <a href="https://gam-medical.de/datenschutzbestimmungen/" target="_blank" rel="noopener noreferrer" className="hover:underline">
          {t('common.datenschutz')}
        </a>
      </footer>
    </div>
  )
}
